<template>
  <div class="scroll-top" @click.stop="scrollToTop" :style="style">
    <svg-icon iconClass="top" color="#fff"></svg-icon>
  </div>
</template>
<script>
export default {
  data () {
    return {
      style: {
        opacity: 0.0
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    handleScroll (e) {
      this.style.opacity = e.target.scrollingElement.scrollTop > 100 ? 0.5 : 0
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>
  .scroll-top {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 0.5rem;
    height: 0.5rem;
    background: $primary-color;
    border-radius: 50%;
    z-index: 500;
    text-align: center;
    line-height: 0.5rem;
    font-size: 0.35rem;
  }
</style>